<div class="container flex-container">
  <div class="panel-content">
    <mat-list>
      <!-- <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <label for="file">File 1</label>
            <input type="file" id="file" (change)="onFileSelected($event)" #fileUpload  />
          </div>
        </div>
      </mat-list-item> -->

      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Reference 1<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('BusRef1', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload1
              name="file"
            />
            <div
              class="doc-upload"
              *ngIf="!getFile('BusRef1'); else elseBlock1"
            >
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button BusRef1"
                color="primary"
                (click)="fileUpload1.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock1>
              <div class="doc-view BusRef1">
                <a (click)="openDoc('BusRef1')">{{
                  displayFileName("BusRef1")
                }}</a>
              </div>
              <div class="doc-delete BusRef1">
                <a (click)="deleteDoc('BusRef1')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Reference 2<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('BusRef2', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload2
            />
            <div
              class="doc-upload"
              *ngIf="!getFile('BusRef2'); else elseBlock2"
            >
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload2.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock2>
              <div class="doc-view">
                <a (click)="openDoc('BusRef2')">{{
                  displayFileName("BusRef2")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('BusRef2')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Company Profile<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('Profile', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload3
            />
            <div
              class="doc-upload"
              *ngIf="!getFile('Profile'); else elseBlock3"
            >
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload3.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock3>
              <div class="doc-view">
                <a (click)="openDoc('Profile')">{{
                  displayFileName("Profile")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('Profile')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Business Plan<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('BusPlan', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload4
            />
            <div
              class="doc-upload"
              *ngIf="!getFile('BusPlan'); else elseBlock4"
            >
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload4.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock4>
              <div class="doc-view">
                <a (click)="openDoc('BusPlan')">{{
                  displayFileName("BusPlan")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('BusPlan')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Owner's Resume<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('Resume', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload5
            />
            <div class="doc-upload" *ngIf="!getFile('Resume'); else elseBlock5">
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload5.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock5>
              <div class="doc-view">
                <a (click)="openDoc('Resume')">{{
                  displayFileName("Resume")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('Resume')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">Copy of Registered Business Licence<span style="color: red;">*</span></div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('License', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload6
            />
            <div
              class="doc-upload"
              *ngIf="!getFile('License'); else elseBlock6"
            >
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload6.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock6>
              <div class="doc-view">
                <a (click)="openDoc('License')">{{
                  displayFileName("License")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('License')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="list-container">
          <div class="row-container">
            <div class="doc-type">China State Ministry Certification</div>
            <input
              type="file"
              class="file-input"
              (change)="onFileSelected('CnCert', $event)"
              accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
              #fileUpload7
            />
            <div class="doc-upload" *ngIf="!getFile('CnCert'); else elseBlock7">
              <button
                mat-stroked-button
                class="seneca-button seneca-stroke-button"
                color="primary"
                (click)="fileUpload7.click()"
              >
                Upload
              </button>
            </div>
            <ng-template #elseBlock7>
              <div class="doc-view">
                <a (click)="openDoc('CnCert')">{{
                  displayFileName("CnCert")
                }}</a>
              </div>
              <div class="doc-delete">
                <a (click)="deleteDoc('CnCert')">
                  <mat-icon>delete</mat-icon><span>Delete</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-list-item>
    </mat-list>

    <!-- <div class="last-modified" *ngIf="latestModified">
      <strong>Last Modified By:</strong> {{latestModified.Uploaded_By}} at {{latestModified.Upload_Date}}
    </div> -->

    <div *ngIf="!hasSigningOfficer()" class="validation-error-message">
      Please set up at least one signing officer in the contacts.
    </div>
    <div *ngIf="!getFile('BusRef1')" class="validation-error-message">
      Reference 1 document is required.
    </div>
    <div *ngIf="!getFile('BusRef2')" class="validation-error-message">
      Reference 2 document is required.
    </div>
    <div *ngIf="!getFile('Profile')" class="validation-error-message">
      Company Profile document is required.
    </div>
    <div *ngIf="!getFile('BusPlan')" class="validation-error-message">
      Business Plan document is required.
    </div>
    <div *ngIf="!getFile('Resume')" class="validation-error-message">
      Owner's Resume document is required.
    </div>
    <div *ngIf="!getFile('License')" class="validation-error-message">
      Copy of Registered Business Licence document is required.
    </div>
    <div class="button-section">
      <button
        mat-stroked-button
        class="seneca-button"
        color="primary"
        (click)="openSaveDialog()"
        [disabled]="isSaving || !hasNewFileUploaded || !ContactInfo || !CompanyInfo 
        || !hasSigningOfficer() || !getFile('BusRef1') || !getFile('BusRef2') || !getFile('Profile') 
        || !getFile('BusPlan') || !getFile('Resume') || !getFile('License')"
      >
        {{ isSaving ? 'Submitting...' : 'Submit' }}
      </button>
      <span class="divider"></span>
      <!-- <button mat-stroked-button type="button" class="seneca-button seneca-stroke-button" (click)="onReset()" [disabled]="!hasNewFileUploaded" color="primary">
        Reset
      </button> -->
    </div>
  </div>
</div>
